import { Box, LinearProgress } from '@mui/material';

import { ChartType } from './ProgressChartType';

type Props = {
    value: number;
    maxValue: number;
    type?: ChartType;
    color? : string;
    height?: number;
  };

export default function ProgressChart(props: Props) {
  const { value, maxValue, type, color, height } = props;
  const percentage = Number.isFinite(value / maxValue) ? (value / maxValue) * 100 : 0;

  const borderRadius = 4;
  const defaultHeight = height ?? 14;

  // Get styles based on chart type
  const getProgressBarStyles = () => {
    switch (type) {
      case ChartType.Negative:
        return {
          root: {
            height: defaultHeight,
            borderTopRightRadius: borderRadius,
            borderBottomRightRadius: borderRadius,
            backgroundColor: '#3BB0FF33',
            transform: 'scaleX(-1)',
          },
          bar: {
            backgroundColor: '#F96C75',
            borderRadius,
          },
        };
      case ChartType.PositiveWithNegativeBack:
        return {
          root: {
            height: defaultHeight,
            borderTopRightRadius: borderRadius,
            borderBottomRightRadius: borderRadius,
            backgroundColor: '#3BB0FF33',
          },
          bar: {
            backgroundColor: '#1BFEBA',
            borderTopRightRadius: borderRadius,
            borderBottomRightRadius: borderRadius,
          },
        };
      default:
        return {
          root: {
            height: defaultHeight,
            borderRadius,
            backgroundColor: '#3BB0FF33',
          },
          bar: {
            backgroundColor: color ?? '#1BFEBA',
            borderTopRightRadius: borderRadius,
            borderBottomRightRadius: borderRadius,
          },
        };
    }
  };

  const styles = getProgressBarStyles();

  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress
        variant="determinate"
        value={percentage === 0 ? -1 : percentage}
        sx={{
          ...styles.root,
          '& .MuiLinearProgress-bar': {
            ...styles.bar,
          },
        }}
      />
    </Box>
  );
}
